// Native
import { useState } from "react"

// Components
import { ButtonGroup, Flex, Td, Text, Tr } from "@chakra-ui/react"
import { IconButton, Lottie, Row, Section, Table, Tag } from "components"

// Config
import { Enums, Moment, Functions } from "config"

// Hooks
import { useOrder, useUser } from "hooks"

// Screens
import { Fiscal as FiscalScreens } from 'screens'

export default function Fiscal({ data }){

    const order = useOrder(data?.id)
    const [ note, setNote ] = useState(false)

    const columns = [{ children: 'Número', isNumeric: true }, { children: 'Status' }, { children: 'Data', isNumeric: true }, { children: '', isNumeric: true }]
    
    if(!order.data?.fiscal?.length) return (
    <>
    
    <Flex direction="column" alignItems="center" justifyContent="center">
        <Lottie animation="empty" style={{ height: 200, transform: 'scale(1)' }} />
        <Text fontWeight="bold" fontSize="large" children="Notas fiscais" />
        <Text fontWeight="bold" fontSize="" children="Nenhuma nota fiscal emitida ainda" />
    </Flex>

    {/* Screens */}
    <FiscalScreens.View isOpen={!!note} data={note} onClose={() => setNote(false)} />
    </>
    )

    return(
    <>
    
    <Section title="Notas fiscais" />

    <Table columns={columns} mt={4}>
        { order.data?.fiscal?.map(item => <Item key={item.id} data={item} setNote={setNote} />) }
    </Table>

    {/* Screens */}
    <FiscalScreens.View isOpen={!!note} data={note} onClose={() => setNote(false)} />
    
    </>
    )
}

const Item = ({ data, setNote = () => {}, ...props }) => {

    const user = useUser()
    let status = Enums.FiscalNoteStatus.data(data.status)

    if(Functions.hasRole(user, 'fiscal_manage')) return(
    <Row onClick={() => setNote(data)}>
        <Td isNumeric children={data.number ?? <>&mdash;</>} />
        <Td><Tag children={`${status.emoji} ${status.label}`} /></Td>
        <Td isNumeric children={Moment(data.created_at).format('LL')} />
        <Td isNumeric>
            <ButtonGroup size="xs">
                <IconButton isDisabled={!data.pdf?.download_url} icon="pdf" label="Download PDF" onClick={() => window.open(data.pdf?.download_url)} />
                <IconButton isDisabled={!data.xml?.download_url} icon="xml" label="Download XML" onClick={() => window.open(data.xml?.download_url)} />
            </ButtonGroup>
        </Td>
    </Row>
    )

    return(
    <Tr>
        <Td isNumeric children={data.number ?? <>&mdash;</>} />
        <Td><Tag children={`${status.emoji} ${status.label}`} /></Td>
        <Td isNumeric children={Moment(data.created_at).format('LL')} />
        <Td isNumeric>
            <ButtonGroup size="xs">
                <IconButton isDisabled={!data.pdf?.download_url} icon="pdf" label="Download PDF" onClick={() => window.open(data.pdf?.download_url)} />
                <IconButton isDisabled={!data.xml?.download_url} icon="xml" label="Download XML" onClick={() => window.open(data.xml?.download_url)} />
            </ButtonGroup>
        </Td>
    </Tr>
    )


}